<template>
  <div class="fileInput">
    <div v-if="defaultValue||value" :style="{backgroundImage: `url(.${defaultValue})`}" @click="del"/>
    <label for="file" v-else title="點擊上傳圖片">
      請上傳圖片
      <input type="file" id="file" name="file" @change="upload" :disabled="disabled">
      <div class="insertImage" :style="[color ? {backgroundColor: color} : {}]">匯入圖片</div>
    </label>
  </div>

</template>

<script>
export default {
  name: 'FileInput',
  props: ['defaultValue', 'folder', 'disabled', 'color'],
  data () {
    return {
      value: null
    }
  },
  methods: {
    del () {
      if (!this.disabled) {
        this.$emit('input', null)
      }
    },
    async upload (ev) {
      if (ev.target.files[0]) {
        const image = await this.$store.dispatch('uploadFile', { event: ev, folder: this.folder })
        console.log('upload Image', image)
        this.$emit('input', `/${this.folder}/${image.filename}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
label, .fileInput {
  display: inline-block;
  max-width: 550px;
  height: 412.5px;
  width: -webkit-fill-available;
  background-color: #E8E8E8;
  border-radius: 10px;
  input[type=file] {
    display: none;
  }
  &>div:nth-child(1) {
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
}
label {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  &::before {
    content: '';
    display: inline-block;
    width: 60px;
    height: 43.64px;
    background-image: url(./svg/btn/camera.svg);
  }
  .insertImage {
    margin-top: 9px;
    background-color: var(--color-pri);
    width: 100px;
    height: 35px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 0;
    font-size: 16px;
  }
}
</style>
